import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client';
import generated from '../../generated/graph-api';
import { authLink } from './links/authentication';
import * as typePolicies from './type-policies';

const uri = process.env.NEXT_PUBLIC_GRAPH_API;
const httpLink = createHttpLink({ uri });

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache({
    typePolicies,
    possibleTypes: generated.possibleTypes,
  }),
});

export { client };
